<template>
  <div class="">
    <div v-if="inited">
      <router-view ref="main-component"/>
    </div>

    <ConfirmationDialog />

    <div v-if="isStoreBusy">
      <Loading></Loading>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Loading from '@/components/Loading.vue';
import ConfirmationDialog from '@/components/ConfirmationDialog'

export default {
  name: 'App',
  data() {
    return {
      inited: true,
    }
  },
  components: {
    ConfirmationDialog,
    Loading,
  },
  async created() {
  },
  watch: {
  },
  computed: {
    ...mapGetters(['isStoreBusy']),
  },
  methods: {
  }
}
</script>

<style lang="scss">
</style>
